import * as yup from 'yup';

export const schema = yup
  .object({
    cod_tipo_ajuste_pai: yup
      .object({
        value: yup.number().required(),
        label: yup.string().required(),
      })
      .required(),
    cod_tipo_ajuste_filho: yup
      .object({
        value: yup.number().required(),
        label: yup.string().required(),
      })
      .required(),
    qtd_producao: yup.string().required(),
  })
  .required();
